import Card from "./Card";
import admin from "../../assets/administracion.png";
import convocatorias from "../../assets/megafono.png";
import postulaciones from "../../assets/convocatorias.png";
import jurados from "../../assets/jurado.png";

const Home = () => {
  return (
    <>
      <section className="pt-5 " id="texto-superior">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h4>
                Bienvenido a Convocatorias de fomento y estímulos para el arte y
                la cultura
              </h4>
              <p className="mb-5 padding-headercards">
                Encuentra aquí los accesos rápidos a las funciones más
                utilizadas.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="content-cards fondo-foto">
        <section id="cards">
          <div className="container">
            <div className="row justify-content-start">
              <Card
                image={admin}
                name="Administrador"
                links={[
                  {
                    name: "Gestionar Roles",
                    to: "/administrador/gestionRoles",
                  },
                  {
                    name: "Gestión Maestras Convocatorias",
                    to: "/administrador/gestionMaestras",
                  },
                  {
                    name: "Gestión Maestras Jurados",
                    to: "/administrador/gestionMaestrasJurados",
                  },
                ]}
              />
              <Card
                image={convocatorias}
                name="Convocatorias"
                links={[
                  {
                    name: "Administrador de Convocatorias",
                    to: "/administrador/tablaconvocatorias"
                  },
                  {
                    name: "Crear Convocatoria Artistas",
                    to: "/administrador/infoconvocatoria",
                    click: () => {
                      localStorage.removeItem('id_convocatoria');
                      localStorage.removeItem('editar_convocatoria');
                    }
                  },
                  {
                    name: "Crear Convocatoria Jurados",
                    to: "/administrador/infoJurados",
                    click: () => {
                      localStorage.removeItem('id_convocatoria');
                      localStorage.removeItem('editar_convocatoria');
                    }
                  },
                  {
                    name: "Crear Convocatoria Beps",
                    to: "/administrador/infoBeps",
                    click: () => {
                      localStorage.removeItem('id_convocatoria');
                      localStorage.removeItem('editar_convocatoria');
                    }
                  },
                ]}
              />
              <Card
              image={postulaciones}
                name="Postulaciones"
                links={[
                  {
                    name: "Proyectos Artistas",
                    to: "/administrador/gestionarPostulaciones",
                  },
                  {
                    name: "Banco de Jurados",
                    to: "/administrador/bancoJurados",
                  },
                  {
                    name: "Beps",
                    to: "/administrador/gestionarPostulacionesBeps",
                  },
                  {
                    name: "Gestión Evaluador",
                    to: "/administrador/gestionEvaluador",
                  },
                ]}
              />
              <Card
                image={jurados}
                name="Gestión Jurados"
                links={[
                  {
                    name: "Asignar Proyectos",
                    to: "/administrador/asignarJurados",
                  },
                  {
                    name: "Resultados de Evaluación",
                    to: "/administrador/seguimientoProyectos",
                  },
                  {
                    name: "Registro de Pagos",
                    to: "/administrador/listadoPostulaciones",
                  },
                ]}
              />
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Home;
